export const iconFontAwesomeMapsTruckMedical = (
	<i className="fa-solid fa-truck-medical"></i>
);
